import { gql } from '@apollo/client/core';

const variantName = {
  VARIANT_NAME: gql`
    fragment VariantName on Variant {
      attributes {
        name
      }
    }
  `,
};

export default variantName;
